import {Link} from "react-router-dom";

export function ButtonBack({ to }) {
    return (
        <Link to={to} className="btn btn-secondary">
            <i className='fas fa-arrow-left me-2'></i>
            Voltar
        </Link>
    )
}